import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import './CustomFilterSwitch.scss';
import { injectIntl } from 'react-intl';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

const recruitmentTabInactiveStyle = { backgroundColor: '#3966f888', color: '#ffffff' };
const recruitmentTabActiveStyle = {
  color: '#3966f8',
  borderTop: 'none',
  borderBottom: '4px solid #3966f8'
};

const CustomFilterSwitch = props => {
  const { intl, customFilters, applyFilter, activeTab, allFilter, reminderFilter, recruitmentFilter } = props;

  return (
    <div className="custom-filter-switch">
      <Grid
        container
        direction="row"
        wrap="nowrap"
        style={{ height: '100%' }}
        sx={{
          alignItems: 'stretch'
        }}
      >
        <Grid size="grow" key={0}>
          <Button
            variant="outlined"
            onClick={allFilter}
            style={
              activeTab[0]
                ? {
                    color: '#3966f8',
                    borderTop: 'none',
                    // borderLeft: '2px solid lightgrey',
                    // borderRight: '2px solid lightgrey',
                    borderBottom: '4px solid #3966f8'
                  }
                : {
                    color: '#00000088'
                  }
            }
          >
            <Grid container sx={{ flexDirection: 'column' }}>
              <Grid className="text">{intl.formatMessage({ id: 'All' })}</Grid>
            </Grid>
          </Button>
        </Grid>
        {customFilters.map((e, index) => {
          const isSelected = activeTab[index + 1];
          return (
            <Grid size="grow" key={index + 1} className={index === 2 ? 'last-filter' : ''}>
              <Button
                className={e.clientState}
                variant="outlined"
                onClick={() => applyFilter(index)}
                style={
                  isSelected
                    ? {
                        color: '#3966f8',
                        borderTop: 'none',
                        // borderLeft: '2px solid lightgrey',
                        // borderRight: '2px solid lightgrey',
                        borderBottom: '4px solid #3966f8'
                      }
                    : {
                        color: '#00000088'
                      }
                }
              >
                <Grid container sx={{ flexDirection: 'column' }}>
                  <Grid className="text">
                    {!e.name ? intl.formatMessage({ id: `custom-filter-${index + 1}` }) : e.name}
                  </Grid>
                </Grid>
              </Button>
            </Grid>
          );
        })}
        <Grid size="grow" key={4}>
          <Button
            variant="outlined"
            onClick={reminderFilter}
            style={
              activeTab[4]
                ? {
                    color: '#3966f8',
                    borderTop: 'none',
                    borderBottom: '3px solid #3966f8'
                  }
                : {
                    color: '#00000088'
                  }
            }
          >
            <Grid container sx={{ flexDirection: 'column' }}>
              <Grid className="text">
                <NotificationsNoneIcon color="primary" />
              </Grid>
            </Grid>
          </Button>
        </Grid>
        <Grid size="grow" key={5}>
          <Button
            variant="outlined"
            onClick={recruitmentFilter}
            style={activeTab[5] ? recruitmentTabActiveStyle : recruitmentTabInactiveStyle}
          >
            <Grid container sx={{ flexDirection: 'column' }}>
              <Grid className="text">{intl.formatMessage({ id: 'recruit' })}</Grid>
            </Grid>
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default injectIntl(CustomFilterSwitch);
